export const isErrorGuard = (e: unknown, code: number) => {
  return typeof e === 'object' && e !== null && 'status' in e && e.status === code;
};
